import { useState } from 'react';

const Playground = () => {
  const [prompt, setPrompt] = useState('你好，请介绍一下你自己。');
  const [output, setOutput] = useState('');

  const handleRun = () => {
    setOutput('（演示模式）请求已发送，接入 API 后将在此显示模型响应…');
  };

  return (
    <>
      <p className="console-panel-desc">在线测试模型调用，选择模型并输入提示词即可快速验证。</p>
      <div className="console-form-row two-col" style={{ marginBottom: '1rem' }}>
        <div>
          <label className="console-label">模型</label>
          <select className="console-input" defaultValue="byt-claude-sonnet-4-20250514">
            <option value="byt-claude-sonnet-4-20250514">byt-claude-sonnet-4</option>
            <option value="byt-gpt-5.5">byt-gpt-5.5</option>
            <option value="byt-gemini-3.1-pro">byt-gemini-3.1-pro</option>
          </select>
        </div>
        <div>
          <label className="console-label">令牌</label>
          <select className="console-input" defaultValue="default">
            <option value="default">默认令牌 · sk-***abc</option>
          </select>
        </div>
      </div>
      <div className="console-playground">
        <textarea
          className="console-playground-editor"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="输入提示词…"
        />
        <textarea
          className="console-playground-output"
          value={output}
          readOnly
          placeholder="模型输出将显示在这里…"
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <button type="button" className="console-btn" onClick={handleRun}>
          运行
        </button>
      </div>
    </>
  );
};

export default Playground;
